import { render, staticRenderFns } from "./createCert.vue?vue&type=template&id=6c43f0ec&scoped=true&"
import script from "./createCert.vue?vue&type=script&lang=js&"
export * from "./createCert.vue?vue&type=script&lang=js&"
import style0 from "./createCert.vue?vue&type=style&index=0&id=6c43f0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c43f0ec",
  null
  
)

component.options.__file = "createCert.vue"
export default component.exports